export function transformClientDataToOffice(data) {
  if (!data) throw Error("missing required arg: data");

  const transformedData = {
    ...data,
    ipList: data.ipList ? data.ipList.join(",") : "",
    senderNumbers: data.senderNumbers ? data.senderNumbers.join(",") : "",
    selectedSenderNumber: data.selectedSenderNumber || "",
  };
  if (data.accountType) transformedData["accountType"] = data.accountType;
  if (data.companyInfo) {
    transformedData["companyInfo"] = {
      ...data.companyInfo,
      billingEmail: data.companyInfo.emailAddress || "",
      vatNr: data.companyInfo.vatNr || "",
      regNr: data.companyInfo.regNr || "",
    };
  }
  return transformedData;
}
